// 自定义的节点,使用html节点
import { HtmlNode, HtmlNodeModel } from "@logicflow/core";
// 继承基础节点
class CustomerNodeModel extends HtmlNodeModel {
    setAttributes() {
        this.text.editable = false; // 禁止节点文本编辑
        // 设置节点宽高和锚点
        const width = 230;
        const height = 100;
        this.width = width;
        this.height = height;
        this.anchorsOffset = [
            [width / 2, 0],
            [0, height / 2],
            [-width / 2, 0],
            [0, -height / 2],
        ];
    }
}
class CustomerNode extends HtmlNode {
    setHtml(rootEl) {
        const { properties } = this.props.model;
        const el = document.createElement("div");
        // html模板代码，svg是图片，如果这个节点设置有问题，就显示错误图标
        el.className = "logic-customer-node node-" + properties.nodeType;
        el.innerHTML = `
        <div class="node-header">
            <span class="name">${properties.nodeName}</span>
            <span class="node-icon ${properties.nodeIcon}"></span>
            ${properties.invalid? '<svg class="error-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M512 64a448 448 0 1 1 0 896.064A448 448 0 0 1 512 64m67.2 275.072c33.28 0 60.288-23.104 60.288-57.344s-27.072-57.344-60.288-57.344c-33.28 0-60.16 23.104-60.16 57.344s26.88 57.344 60.16 57.344M590.912 699.2c0-6.848 2.368-24.64 1.024-34.752l-52.608 60.544c-10.88 11.456-24.512 19.392-30.912 17.28a12.992 12.992 0 0 1-8.256-14.72l87.68-276.992c7.168-35.136-12.544-67.2-54.336-71.296-44.096 0-108.992 44.736-148.48 101.504 0 6.784-1.28 23.68.064 33.792l52.544-60.608c10.88-11.328 23.552-19.328 29.952-17.152a12.8 12.8 0 0 1 7.808 16.128L388.48 728.576c-10.048 32.256 8.96 63.872 55.04 71.04 67.84 0 107.904-43.648 147.456-100.416z"></path></svg>': ''}
        </div>
        <div class="node-body">
          <div>${properties.message || ""}</div>
        </div>
    `;
        // 需要先把之前渲染的子节点清除掉。
        rootEl.innerHTML = "";
        rootEl.appendChild(el);
    }
}
export default {
    type: "CustomerNode",
    view: CustomerNode,
    model: CustomerNodeModel
};